/**
 * @file     elementFromPointClick.ts
 * @purpose  Detect the Google Ads / in-app-browser one-liner that calls
 *           document.elementFromPoint(x, y).click() with coordinates outside
 *           the viewport. elementFromPoint returns null there; the unguarded
 *           .click() is third-party click-replay, not an app defect.
 */

const ELEMENT_FROM_POINT_CLICK =
  /document\.elementFromPoint\s*\([^)]*\)\s*\.click/;

/** True when a third-party script clicked a point outside the viewport. */
export function isElementFromPointClickError(
  error: { name?: string; message?: string; stack?: string } | null | undefined,
): boolean {
  if (!error) return false;
  const haystack = `${error.message ?? ''}\n${error.stack ?? ''}`;
  return ELEMENT_FROM_POINT_CLICK.test(haystack);
}
